import React, { useEffect }  from "react"
import styled from 'styled-components'

import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"

const SectionOneV3 = () => {

    useEffect(() => {

        if (typeof window !== `undefined`) {
            gsap.registerPlugin(ScrollTrigger)
            gsap.core.globals('ScrollTrigger', ScrollTrigger)
        }

        ScrollTrigger.matchMedia({
            "(min-width: 1201px)": function() {
                
                //section one animate content

                let tlTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#section_one_content",
                        start: 'top 80%',
                        end: 'top 80%',
                        id: 'section_one_content',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                tlTwo.to('.da-content', { duration: .3, opacity: '1', top: '0' }, 0.5)
                
            },
            "(max-width: 1200px)": function() {

                let daMobileTwo = gsap.timeline({
                    paused: true,
                    scrollTrigger: {
                        trigger: "#da_mobile_two",
                        start: 'top 90%',
                        end: 'top 90%',
                        id: 'da_mobile_two',
                        toggleActions: "play play reverse reverse",
                        },
                    })
                daMobileTwo.to('.da-content', { duration: .5, opacity: '1', top: '0' }, 0.5)

            }
        });

    }, []);

    return(
        <MainSection id="section_one_content">
            <div class="da-content"  id="da_mobile_two">
                <p>Hahn, originally founded in 1974, is an agile team of marketing and PR experts promoting and protecting food and energy brands using predictive analytics, award-winning creative, and a whole lot of hustle.</p>
            </div>
            <div class="border-bottom"></div>
        </MainSection>
    );

}

const MainSection = styled.section`
    position: relative;
    max-width: 1310px;
    width: 100%;
    margin: 100px auto;
    padding: 0 20px;
    display: flex;
    flex-wrap: wrap;
    .da-content {
        margin: 0 auto;
        opacity: 0;
        position: relative;
        top: 20px;
        h3 {
            font-family: "Work Sans";
            font-size: 30px;
            line-height: 36px;
            font-weight: 400;
            color: #2b2520;
            margin-top: 0;
            margin-bottom: 10px;
        }
        p {
            font-family: "Work Sans";
            font-size: 24px;
            line-height: 2;
            font-weight: 400;
            color: #777c7c;
            margin-top: 0;
            margin-bottom: 0px;
            text-align: center;
        }
        a {
            font-family: "Work Sans";
            font-size: 20px;
            line-height: 24px;
            font-weight: 700;
            color: #2b2520;
            margin-top: 10px;
            margin-bottom: 10px;
            text-decoration: none;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            transition-duration: .3s;
            svg {
              width: 24px;
              margin-left: 10px;
              transition: all .3s cubic-bezier(.77,0,.175,1);
            }
            &:hover {
              color: #C44C4A !important;
              svg {
                transform: translateX(10px);
              }
            }
        }
    }
    .border-bottom {
        height: 23px;
        width: 100%;
        background-color: #eaeaea;
        margin-top: 100px;
    }
    @media(max-width: 1000px) {
        flex-wrap: wrap;
        max-width: 700px;
    }
    @media(max-width:767px) {
        max-width: 500px;
        width: 100%;
        overflow: hidden;
        margin: 50px auto;
        .da-content {
            h3 {
                font-size: 24px;
                line-height: 1.2;
            }
            p {
                font-size: 16px;
                line-height: 1.6;
            }
            a {
                font-size: 18px;
            }
        }
        .border-bottom {
            margin-top: 40px;
        }
    }
`

export default SectionOneV3